import React from "react";
import LiquidBackground from "./LiquidBackground";
import shellStyles from "../styles/liquidShell.module.css";

/**
 * Marketing pages: fixed WebGL liquid backdrop + vignette overlay (matches landing).
 */
export default function LiquidPageShell({ children }) {
  return (
    <div className={shellStyles.pageRoot}>
      <LiquidBackground className={shellStyles.liquidBgLayer} />
      <div className={shellStyles.pageMain}>{children}</div>
    </div>
  );
}
